import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[appOnlyNumber]'
})
export class OnlyNumber {
    constructor(private _el: ElementRef) {
    }
    @HostListener('input', ['$event']) onInputChange(event) {
        let initalValue = '';
        if (this._el.nativeElement.localName == "sirius-textbox") {
            initalValue = this._el.nativeElement.children[0].value.trim();
            this._el.nativeElement.children[0].value = initalValue.trim().replace(/[^0-9]*/g, '');
            if (initalValue !== this._el.nativeElement.children[0].value) {
                event.stopPropagation();
            }
        }
        else {
            initalValue = this._el.nativeElement.value.trim();
            this._el.nativeElement.value = initalValue.trim().replace(/[^0-9]*/g, '');
            if (initalValue !== this._el.nativeElement.value) {
                event.stopPropagation();
            }
        }
    } 
   
    @HostListener('paste', ['$event'])
    onPaste(event: Event) {
        setTimeout(() => {
            const input = (<HTMLInputElement>event.target);
            input.value = input.value.trim().replace(/\D/g, '');
        });
    }

}